import { ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import {
    RateReview,
    CheckCircleOutline,
    Block,
    CalendarMonth,
    Pending,
    TaskAlt,
    AssignmentOutlined,
} from "@mui/icons-material";
import { EJobStatuses } from "../../jobs/enum/job.enums";
import { colors } from "../../ui/colors";

interface WorkforceTasksFilterProps {
    status: EJobStatuses | "all" | null;
    onSelectFilter: (status: EJobStatuses | "all") => void;
}

const STATUS_CONFIG = {
    all: { label: "All Tasks", icon: <AssignmentOutlined sx={{ fontSize: 18 }} /> },
    [EJobStatuses.FOR_REVISION]: { label: "For Revision", icon: <RateReview sx={{ fontSize: 18 }} /> },
    [EJobStatuses.APPROVED]: { label: "Approved", icon: <CheckCircleOutline sx={{ fontSize: 18 }} /> },
    [EJobStatuses.CANCELLED]: { label: "Cancelled", icon: <Block sx={{ fontSize: 18 }} /> },
    [EJobStatuses.SCHEDULED]: { label: "Scheduled", icon: <CalendarMonth sx={{ fontSize: 18 }} /> },
    [EJobStatuses.IN_PROGRESS]: { label: "In Progress", icon: <Pending sx={{ fontSize: 18 }} /> },
    [EJobStatuses.COMPLETED]: { label: "Completed", icon: <TaskAlt sx={{ fontSize: 18 }} /> },
};

export const WorkforceTasksFilter = ({ status, onSelectFilter }: WorkforceTasksFilterProps) => {
    const activeStatus = status ?? "all";

    return (
        <ToggleButtonGroup
            value={activeStatus}
            exclusive
            onChange={(_, value) => value && onSelectFilter(value as EJobStatuses | "all")}
            size="small"
            sx={{
                bgcolor: "transparent",
                "@keyframes fadeIn": {
                    from: { opacity: 0, transform: "translateX(-4px)" },
                    to: { opacity: 1, transform: "translateX(0)" },
                },
                "& .MuiToggleButton-root": {
                    border: "none",
                    borderRadius: "12px !important",
                    mx: 0.1,
                    px: 1.25,
                    py: 0.75,
                    gap: 1,
                    textTransform: "none",
                    color: colors.gray[400],
                    transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                    "&:hover": {
                        bgcolor: colors.gray[50],
                        color: colors.gray[600],
                    },
                    "&.Mui-selected": {
                        bgcolor: colors.orange[50],
                        color: colors.orange[700],
                        "&:hover": { bgcolor: colors.orange[100] },
                    },
                },
            }}
        >
            {Object.entries(STATUS_CONFIG).map(([key, { label, icon }]) => (
                <Tooltip
                    key={key}
                    title={label}
                    placement="top"
                    arrow
                    slotProps={{ popper: { sx: { zIndex: 9999 } } }}
                >
                    <ToggleButton value={key}>
                        {icon}
                        <Typography
                            variant="caption"
                            sx={{
                                fontWeight: 700,
                                fontSize: "0.75rem",
                                whiteSpace: "nowrap",
                                animation: "fadeIn 0.2s ease-out",
                            }}
                        >
                            {label}
                        </Typography>

                    </ToggleButton>
                </Tooltip>
            ))}
        </ToggleButtonGroup>
    );
};